import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgIconModule } from '@app/src/app/icon';
import { MgPipesModule } from '@app/src/app/pipes';
import { NotificationsModule } from '@app/src/app/routes/home/Notifications';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { HpmDashboardPipesModule } from '@modules/hallpass-manager/components/hpm-dashboard/pipes/hpm-dashboard-pipes.module';

import { CarouselModule } from '@shared/components/carousel/carousel.module';
import { PlaceholderModule } from '@shared/components/placeholder/placeholder.module';
import { TextModule } from '@shared/components/text/text.module';
import { StudentPictureModule } from '@shared/directives/student-picture/student-picture.module';
import { CommonUIModules } from '@shared/modules';

import { ToolsNotificationsComponent } from '../components/tools-notifications/tools-notifications.component';
import { ToolsActionsButtonComponent } from './components/tools-actions-button/tools-actions-button.component';
import { ToolsActionsHeaderComponent } from './components/tools-actions-header/tools-actions-header.component';
import { ToolsGroupsViewModalComponent } from './components/tools-groups-view-modal/tools-groups-view-modal.component';
import { ToolsGroupsComponent } from './components/tools-groups/tools-groups.component';
import { ToolsLinkComponent } from './components/tools-link/tools-link.component';
import { ToolsMetricsCardComponent } from './components/tools-metrics-card/tools-metrics-card.component';
import { ToolsNavItemComponent } from './components/tools-nav-item/tools-nav-item.component';
import { ToolsNavComponent } from './components/tools-nav/tools-nav.component';
import { ToolsSplitCardComponent } from './components/tools-split-card/tools-split-card.component';
import { ToolsStatsPlaceholderComponent } from './components/tools-stats-placeholder/tools-stats-placeholder.component';
import { ToolsStickersViewModalComponent } from './components/tools-stickers-view-modal/tools-stickers-view-modal.component';
import { ToolsStickersComponent } from './components/tools-stickers/tools-stickers.component';
import { ToolsTwoColLayoutComponent } from './components/tools-two-col-layout/tools-two-col-layout.component';
import { FilterHpOptionsPipe, FilterPbisOptionsPipe } from './pipes';

@NgModule({
  declarations: [
    ToolsLinkComponent,
    ToolsNavItemComponent,
    ToolsNavComponent,
    ToolsGroupsComponent,
    ToolsGroupsViewModalComponent,
    ToolsNotificationsComponent,
    FilterPbisOptionsPipe,
    FilterHpOptionsPipe,
    ToolsTwoColLayoutComponent,
    ToolsStickersComponent,
    ToolsStickersViewModalComponent,
    ToolsActionsHeaderComponent,
    ToolsActionsButtonComponent,
    ToolsMetricsCardComponent,
    ToolsStatsPlaceholderComponent,
    ToolsSplitCardComponent,
  ],
  imports: [
    MgIconModule,
    FlexLayoutModule,
    CommonModule,
    CommonUIModules,
    TextModule,
    NotificationsModule,
    CarouselModule,
    RouterModule,
    MgEmptyStateModule,
    MgSpinnerModule,
    MgImageModule,
    MgPipesModule,
    PlaceholderModule,
    MgAvatarModule,
    MatTooltipModule,
    MatMenuModule,
    CommonUIModules,
    HpmDashboardPipesModule,
    StudentPictureModule,
  ],
  exports: [
    ToolsLinkComponent,
    ToolsNavItemComponent,
    ToolsNavComponent,
    ToolsGroupsComponent,
    ToolsNotificationsComponent,
    FilterPbisOptionsPipe,
    FilterHpOptionsPipe,
    ToolsTwoColLayoutComponent,
    ToolsStickersComponent,
    ToolsActionsHeaderComponent,
    ToolsActionsButtonComponent,
    ToolsMetricsCardComponent,
    ToolsStatsPlaceholderComponent,
    ToolsSplitCardComponent,
  ],
})
export class SharedToolsModule {}
